<template>
  <header class="navbar-top" style="padding-right: 30px">
    <span>待售明細</span>
    <div class="input-group" style="width: 50%">
      <input
        type="text"
        class="form-control"
        placeholder="先放在這佔位"
        aria-label="先放在這佔位"
        aria-describedby="button-addon2"
      />
      <button
        class="btn btn-outline-primary material-icons align-middle"
        type="button"
        id="button-addon2"
      >
        search
      </button>
    </div>
  </header>

  <section class="content">
    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th scope="col">商品名稱</th>
            <th scope="col">角色名稱</th>
            <th scope="col">出售價格</th>
            <th scope="col">備註</th>
          </tr>
        </thead>
        <tbody>
          <td>第六彈饅頭</td>
          <td>敬人</td>
          <td>145</td>
          <td>自留友也、創、司、凜月、嵐</td>
        </tbody>
      </table>
    </div>
  </section>
  <footer class="footer"></footer>
</template>
